function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import AssetComponent from "components/core/asset/asset-component";
import WindowMask from "segments/desktop/core-components/window-mask/window-mask";
import classnames from "classnames";
import VisibilitySensor from "react-visibility-sensor";
import DefaultProps from "./default-props";
import { StyledMasonryGridComponent } from "./masonry-grid-component.scss";
const MasonryGridComponent = (props)=>{
    var _assets_, _assets_1, _assets_2, _assets_3, _assets_4, _assets_5, _assets_6, _assets_7, _assets_8;
    const { assets, hideControls, alignToLogo } = props;
    const [wasComponentEverVisible, setWasComponentEverVisible] = useState(false);
    const [assetTimingsProps, setAssetTimingsProps] = useState([]);
    const VISIBILITY_SENSOR_OFFSET = 100;
    const updateAssetTimingsProps = ({ index })=>{
        var _assets_index, _assets_index_asset, _assets_index1;
        const updatedAssetTimingsProps = [
            ...assetTimingsProps
        ];
        updatedAssetTimingsProps[index] = _object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_index = assets[index]) === null || _assets_index === void 0 ? void 0 : _assets_index.asset), {
            video: _object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_index1 = assets[index]) === null || _assets_index1 === void 0 ? void 0 : (_assets_index_asset = _assets_index1.asset) === null || _assets_index_asset === void 0 ? void 0 : _assets_index_asset.video), {
                autoPlay: true
            })
        });
        setAssetTimingsProps(updatedAssetTimingsProps);
    };
    useEffect(()=>{
        if (wasComponentEverVisible) {
            assets === null || assets === void 0 ? void 0 : assets.forEach(({ asset }, index)=>{
                var _asset_video;
                setTimeout(()=>{
                    updateAssetTimingsProps({
                        index
                    });
                }, Number(asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : _asset_video.startAfter) || 0);
            });
        }
        return ()=>{};
    }, [
        wasComponentEverVisible
    ]);
    const onVisibilityChange = (isVisible)=>{
        if (!wasComponentEverVisible && isVisible) {
            setWasComponentEverVisible(true);
        }
    };
    return /*#__PURE__*/ _jsx(VisibilitySensor, {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ _jsx(StyledMasonryGridComponent, {
            className: "masonry-grid-component",
            children: /*#__PURE__*/ _jsxs("div", {
                className: classnames("grid-container", {
                    "align-to-logo": alignToLogo
                }),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("item", "item1", "timeline"),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_ = assets[0]) === null || _assets_ === void 0 ? void 0 : _assets_.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[0]))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("item", "item2", "status"),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_1 = assets[1]) === null || _assets_1 === void 0 ? void 0 : _assets_1.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[1]))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("item", "item3", "battery"),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_2 = assets[2]) === null || _assets_2 === void 0 ? void 0 : _assets_2.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[2]))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("item", "item4", "integration"),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_3 = assets[3]) === null || _assets_3 === void 0 ? void 0 : _assets_3.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[3]))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("item", "item5", "pie"),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_4 = assets[4]) === null || _assets_4 === void 0 ? void 0 : _assets_4.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[4]))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("item", "item6", "mobile"),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_5 = assets[5]) === null || _assets_5 === void 0 ? void 0 : _assets_5.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[5]))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("item", "item7", "automation"),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_6 = assets[6]) === null || _assets_6 === void 0 ? void 0 : _assets_6.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[6]))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("item", "item8", "comment"),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_7 = assets[7]) === null || _assets_7 === void 0 ? void 0 : _assets_7.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[7]))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("item", "item9", "dashboard"),
                        children: /*#__PURE__*/ _jsx(WindowMask, {
                            children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_8 = assets[8]) === null || _assets_8 === void 0 ? void 0 : _assets_8.asset), {
                                hideControls: hideControls
                            }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[8]))
                        })
                    })
                ]
            })
        })
    });
};
MasonryGridComponent.defaultProps = DefaultProps;
export default MasonryGridComponent;
